import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteHeader } from "@/components/site-header";

export function AdminLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SiteHeader variant="admin" />
      <Outlet />
      <Toaster />
    </div>
  );
}
